import { useState } from 'react';
import { Stack, Link, Box, useTheme, useMediaQuery, Tabs, Tab } from '@mui/material';
import { GooglePlayIcon, AppStoreIcon, AppStoreQR, GooglePlayQR } from '@carcareers/assets';
import { GOOGLE_PLAY_URL, APP_STORE_URL } from '@carcareers/utils';

export const AppLinks = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [activeTab, setActiveTab] = useState<'google' | 'apple'>('google');

  const handleTabChange = (_event: React.SyntheticEvent, newValue: 'google' | 'apple') => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, alignItems: 'center' }}>
      {!isMobile && (
        <>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            aria-label="App store selection"
            sx={{
              '& .MuiTabs-indicator': {
                backgroundColor: 'primary.main',
              },
            }}
          >
            <Tab
              label="Google Play"
              value="google"
              sx={{
                textTransform: 'none',
                fontSize: '1rem',
                fontWeight: activeTab === 'google' ? 600 : 400,
              }}
            />
            <Tab
              label="App Store"
              value="apple"
              sx={{
                textTransform: 'none',
                fontSize: '1rem',
                fontWeight: activeTab === 'apple' ? 600 : 400,
              }}
            />
          </Tabs>
          <Box
            sx={{
              width: { sm: 200, md: 250 },
              height: { sm: 200, md: 250 },
              border: '1px solid',
              borderColor: 'grey.300',
              borderRadius: 2,
              p: 1,
              bgcolor: 'background.paper',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              '& > *': {
                width: '100% !important',
                height: '100% !important',
                maxWidth: '100%',
                maxHeight: '100%',
              },
            }}
          >
            {activeTab === 'google' ? <GooglePlayQR /> : <AppStoreQR />}
          </Box>
        </>
      )}
      {isMobile && (
        <Stack direction="column" spacing={2}>
          <Link href={GOOGLE_PLAY_URL} target="_blank" rel="noopener noreferrer">
            <Box
              sx={{
                width: { xs: 150, sm: 175, md: 200 },
                height: 'auto',
                transition: 'transform 0.2s',
                '&:hover': {
                  transform: 'scale(1.05)',
                },
              }}
            >
              <GooglePlayIcon />
            </Box>
          </Link>
          <Link href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
            <Box
              sx={{
                width: { xs: 150, sm: 175, md: 200 },
                height: 'auto',
                ml: -2,
                transition: 'transform 0.2s',
                '&:hover': {
                  transform: 'scale(1.05)',
                },
              }}
            >
              <AppStoreIcon />
            </Box>
          </Link>
        </Stack>
      )}
    </Box>
  );
};
